import {Map} from 'js/reusable/types/general';
import { 
	REPORT_ACTION_FORMATS, 
	REPORT_SCHEDULES, 
	REPORT_ACTION_TYPES,
	REPORT_DATE_TYPES,
} from 'js/admin/components/reports/types/enums';
import {__} from 'js/tool/page/current';

export const SCHEDULES_TRANSLATIONS: Map = {
	[REPORT_SCHEDULES.ONLY_ONCE]:          'report:only once',
	[REPORT_SCHEDULES.EVERY_MONDAY]:       'report:every monday',
	[REPORT_SCHEDULES.EVERY_WEEKDAY]:      'report:every weekday',
	[REPORT_SCHEDULES.FIRST_OF_THE_MONTH]: 'report:first of the month',
};

export const ACTION_TYPE_TRANSLATIONS: Map = {
	[REPORT_ACTION_TYPES.EMAIL]:     'report:send email',
	[REPORT_ACTION_TYPES.SHOW]:      'report:show only',
	[REPORT_ACTION_TYPES.URL]:       'report:share url',
	[REPORT_ACTION_TYPES.BIG_QUERY]: 'report:bigquery',
};

export const ACTION_FORMAT_TRANSLATIONS: Map = {
	[REPORT_ACTION_FORMATS.JSON]:   'report:json',
	[REPORT_ACTION_FORMATS.CSV]:    'report:csv',
	[REPORT_ACTION_FORMATS.EXCEL]:  'report:excel',
	[REPORT_ACTION_FORMATS.INLINE]: 'report:inline',
};

export const CONSTANT_DATE_TYPE_TRANSLATIONS: Map = {
	[REPORT_DATE_TYPES.TODAY]:             'filter:* today',
	[REPORT_DATE_TYPES.YESTERDAY]:         'filter:* yesterday',
	[REPORT_DATE_TYPES.CURRENT_WEEK]:      'filter:* current week',
	[REPORT_DATE_TYPES.PREVIOUS_WEEK]:     'filter:* previous week',
	[REPORT_DATE_TYPES.PREVIOUS_MONTH]:    'filter:* previous month',
	[REPORT_DATE_TYPES.CURRENT_MONTH]:     'filter:* current month',
	[REPORT_DATE_TYPES.PREVIOUS_3_MONTHS]: 'filter:* last 3 months',
	[REPORT_DATE_TYPES.CURRENT_YEAR]:      'filter:* this year',
};

export const DATE_TYPE_TRANSLATIONS: Map = {
	...CONSTANT_DATE_TYPE_TRANSLATIONS,
	[REPORT_DATE_TYPES.CUSTOM]:    'calendar:custom range',
	[REPORT_DATE_TYPES.FROM]:      'filter:* from',
	[REPORT_DATE_TYPES.LAST]:      'filter:last',
	[REPORT_DATE_TYPES.PREVIOUS]:  'report:previous',
	[REPORT_DATE_TYPES.UNLIMITED]: 'filter:* unlimited',
};

export const DAYS_VALUE = 'days_value';

export const DATE_SCHEDULE = 'date_schedule';

export const SQL_FACEBOOK_BILLING = 'sql_facebook_billing';

export const FLAT_FACEBOOK_GLOBAL_ONBOARDING_DATA = 'flat_facebook_global_onboarding_data';

export const SQL_FACEBOOK_GLOBAL = 'sql_facebook_global_new_report';

export const SQL_FACEBOOK_GLOBAL_NEW = 'sql_facebook_global_new';

export const SQL_FACEBOOK_INVOICE_GLOBAL = 'sql_facebook_invoice_global';

export const DATASETS = [
	{value: SQL_FACEBOOK_BILLING, label: __('fbs:billing data')},
	{value: FLAT_FACEBOOK_GLOBAL_ONBOARDING_DATA, label: __('fbs:entity dataset')},
	{value: SQL_FACEBOOK_GLOBAL, label: __('fbs:facebook global')},
	{value: SQL_FACEBOOK_INVOICE_GLOBAL, label: __('fb:sql facebook invoice global')},
];

export const DEPRECATED_DATASETS = [
	{value: SQL_FACEBOOK_GLOBAL_NEW, label: __('fbs:facebook global new')},
];

export const DATE_TYPE_PREVIOUS = 'previous';

export const DATE_TYPE_LAST     = 'last';

export const DATE_TYPE_FROM     = 'from';

export const DATE_TYPE_CUSTOM   = 'custom';

export const ACTION_EMAIL   = 'email';

export const ACTION_URL     = 'url';

export const EXTERNAL_AD_ACCOUNT = 'external_ad_account';

export const EXTERNAL_ADVERTISER = 'external_advertiser';

export const AD_ACCOUNT          = 'ad_account';
